// // import React from 'react';
// // import { Instagram, Linkedin, Twitter, ArrowRight } from 'lucide-react';
// // import { footer } from '../mockData';

// // const Footer = () => {
// //   const getSocialIcon = (social) => {
// //     switch (social) {
// //       case 'instagram':
// //         return <Instagram className="w-5 h-5" />;
// //       case 'linkedin':
// //         return <Linkedin className="w-5 h-5" />;
// //       case 'twitter':
// //         return <Twitter className="w-5 h-5" />;
// //       default:
// //         return null;
// //     }
// //   };

// //   return (
// //     <footer className="bg-gradient-to-br from-gray-50 to-white border-t border-gray-200">
// //       <div className="max-w-7xl mx-auto px-6 py-16">
// //         {/* Top Section with Logo and Links */}
// //         <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
// //           {/* Logo */}
// //           <div>
// //             <div className="flex items-center space-x-2 mb-4">
// //               <img 
// //   src="https://pub-3c9608891c7244c2a3a8c20309745abf.r2.dev/5a467318-6398-432a-bbce-60cba851785c.png" 
// //   alt="Logo"
// //   className="h-[40px] w-auto object-contain"
// // />
// //               <span className="text-xl font-bold">{footer.logo}</span>
// //             </div>
// //           </div>

// //           {/* Link Sections */}
// //           {footer.sections.map((section, index) => (
// //             <div key={index}>
// //               <h3 className="font-bold mb-4">{section.title}</h3>
// //               <ul className="space-y-2">
// //                 {section.links.map((link, linkIndex) => (
// //                   <li key={linkIndex}>
// //                     <a href={link.href} className="text-gray-600 hover:text-black transition-colors">
// //                       {link.label}
// //                     </a>
// //                   </li>
// //                 ))}
// //               </ul>
// //             </div>
// //           ))}

// //           {/* Stay Connected with Social Icons */}
// //           <div>
// //             <h3 className="font-bold mb-4">Stay Connected</h3>
// //             <div className="flex space-x-4">
// //               {footer.socials.map((social, index) => (
// //                 <a 
// //                   key={index} 
// //                   href="#" 
// //                   className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-gray-200 transition-colors"
// //                 >
// //                   {getSocialIcon(social)}
// //                 </a>
// //               ))}
// //             </div>
// //           </div>
// //         </div>

// //         {/* Cards Section */}
// //         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
// //           {footer.cards.map((card, index) => (
// //             <div key={index} className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300">
// //               <h3 className="text-xl font-bold mb-3">{card.title}</h3>
// //               <p className="text-gray-600 mb-4">{card.description}</p>
// //               <a href="#" className="inline-flex items-center text-brand-blue-600 font-medium hover:text-brand-blue-700">
// //                 {card.cta}
// //                 <ArrowRight className="w-4 h-4 ml-2" />
// //               </a>
// //             </div>
// //           ))}
// //         </div>

// //         {/* Bottom Section */}
// //         <div className="border-t border-gray-200 pt-8">
// //           <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
// //             <p className="text-gray-600 text-sm text-center md:text-left">{footer.copyright}</p>
// //             <div className="flex flex-wrap justify-center md:justify-end gap-4">
// //               {footer.bottomLinks.map((link, index) => (
// //                 <a key={index} href={link.href} className="text-gray-600 hover:text-black text-sm transition-colors">
// //                   {link.label}
// //                 </a>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </footer>
// //   );
// // };

// // export default Footer;

// import React from 'react';
// import { Instagram, Linkedin, Twitter, ArrowRight } from 'lucide-react';
// import { footer } from '@/mockData';

// const Footer = () => {
//   const getSocialIcon = (social) => {
//     switch (social) {
//       case 'instagram':
//         return <Instagram className="w-5 h-5" />;
//       case 'linkedin':
//         return <Linkedin className="w-5 h-5" />;
//       case 'twitter':
//         return <Twitter className="w-5 h-5" />;
//       default:
//         return null;
//     }
//   };

//   return (
//     // DIUBAH: Dihapus 'bg-gradient-to-br from-gray-50 to-white' dan 'border-gray-200'
//     <footer className="border-t border-gray-800">
//       <div className="max-w-7xl mx-auto px-6 py-16">
//         {/* Top Section with Logo and Links */}
//         <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
//           {/* Logo */}
//           <div>
//             <div className="flex items-center space-x-2 mb-4">
//               <img 
//                 src="https://pub-3c9608891c7244c2a3a8c20309745abf.r2.dev/5a467318-6398-432a-bbce-60cba851785c.png" 
//                 alt="Logo"
//                 className="h-[40px] w-auto object-contain"
//               />
//               {/* DIUBAH: Teks logo diubah menjadi 'text-white' */}
//               <span className="text-xl font-bold text-white">{footer.logo}</span>
//             </div>
//           </div>

//           {/* Link Sections */}
//           {footer.sections.map((section, index) => (
//             <div key={index}>
//               {/* DIUBAH: Teks judul seksi diubah menjadi 'text-white' */}
//               <h3 className="font-bold mb-4 text-white">{section.title}</h3>
//               <ul className="space-y-2">
//                 {section.links.map((link, linkIndex) => (
//                   <li key={linkIndex}>
//                     {/* DIUBAH: Teks link diubah menjadi 'text-gray-300' */}
//                     <a href={link.href} className="text-gray-300 hover:text-white transition-colors">
//                       {link.label}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           ))}

//           {/* Stay Connected with Social Icons */}
//           <div>
//             {/* DIUBAH: Teks judul seksi diubah menjadi 'text-white' */}
//             <h3 className="font-bold mb-4 text-white">Stay Connected</h3>
//             <div className="flex space-x-4">
//               {footer.socials.map((social, index) => (
//                 <a 
//                   key={index} 
//                   href="#" 
//                   // DIUBAH: Tombol sosial disesuaikan untuk dark mode
//                   className="w-10 h-10 bg-gray-800/50 text-white rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors"
//                 >
//                   {getSocialIcon(social)}
//                 </a>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Cards Section */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
//           {footer.cards.map((card, index) => (
//             // DIUBAH: 'bg-gray-50' diubah menjadi 'bg-black/30 backdrop-blur-lg border'
//             <div key={index} className="bg-black/30 backdrop-blur-lg border border-gray-700/50 rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300">
//               {/* DIUBAH: Teks judul card diubah menjadi 'text-white' */}
//               <h3 className="text-xl font-bold mb-3 text-white">{card.title}</h3>
//               {/* DIUBAH: Teks deskripsi card diubah menjadi 'text-gray-300' */}
//               <p className="text-gray-300 mb-4">{card.description}</p>
//               {/* Link ini sudah OK */}
//               <a href="#" className="inline-flex items-center text-brand-blue-400 font-medium hover:text-brand-blue-300">
//                 {card.cta}
//                 <ArrowRight className="w-4 h-4 ml-2" />
//               </a>
//             </div>
//           ))}
//         </div>

//         {/* Bottom Section */}
//         {/* DIUBAH: Border diubah menjadi 'border-gray-800' */}
//         <div className="border-t border-gray-800 pt-8">
//           <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
//             {/* DIUBAH: Teks copyright diubah menjadi 'text-gray-400' */}
//             <p className="text-gray-400 text-sm text-center md:text-left">{footer.copyright}</p>
//             <div className="flex flex-wrap justify-center md:justify-end gap-4">
//               {footer.bottomLinks.map((link, index) => (
//                 // DIUBAH: Teks link bawah diubah menjadi 'text-gray-400'
//                 <a key={index} href={link.href} className="text-gray-400 hover:text-white text-sm transition-colors">
//                   {link.label}
//                 </a>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React from 'react';
import { Instagram, Linkedin, Twitter, ArrowRight } from 'lucide-react';
// DIUBAH: Menggunakan path impor alias '@'
import { footer } from '@/mockData';

const Footer = () => {
  // --- LOGIKA BARU UNTUK LINK SOSIAL DINAMIS ---

  // 1. Cari section 'Connect' dari mockData
  const connectSection = footer.sections.find(
    (section) => section.title.toLowerCase() === 'connect'
  );

  // 2. Buat lookup map (e.g., { instagram: 'https://...' })
  //    Ini akan mengambil SEMUA link dari section 'Connect'
  const socialLinksMap = connectSection?.links.reduce((acc, link) => {
    // Ubah label (e.g., "Instagram") menjadi key (e.g., "instagram")
    const key = link.label.toLowerCase();
    acc[key] = link.href;
    return acc;
  }, {}) || {}; // Fallback ke object kosong jika 'Connect' tidak ditemukan

  // 3. Hapus object 'socialLinks' yang di-hardcode (sudah dihapus)

  const getSocialIcon = (social) => {
    switch (social) {
      case 'instagram':
        return <Instagram className="w-5 h-5" />;
      case 'linkedin':
        return <Linkedin className="w-5 h-5" />;
      case 'twitter':
        return <Twitter className="w-5 h-5" />;
      // Anda bisa menambahkan ikon lain di sini (misal: 'facebook')
      default:
        return null;
    }
  };
  // --- AKHIR LOGIKA BARU ---

  return (
    // DIUBAH: Dihapus 'bg-gradient-to-br from-gray-50 to-white' dan 'border-gray-200'
    <footer className="border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Top Section with Logo and Links */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          {/* Logo */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="https://kontentutorialmpstore-cdn.maduraprime.com/5a467318-6398-432a-bbce-60cba851785c.png"
                alt="Logo"
                className="h-[40px] w-auto object-contain"
              />
              {/* DIUBAH: Teks logo diubah menjadi 'text-white' */}
              <span className="text-xl font-bold text-white">{footer.logo}</span>
            </div>
          </div>

          {/* Link Sections */}
          {footer.sections.map((section, index) => (
            <div key={index}>
              {/* DIUBAH: Teks judul seksi diubah menjadi 'text-white' */}
              <h3 className="font-bold mb-4 text-white">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {/* DIUBAH: Teks link diubah menjadi 'text-gray-300' */}
                    {/* DIUBAH: Menambahkan target="_blank" */}
                    <a
                      href={link.href}
                      className="text-gray-300 hover:text-white transition-colors"
                      // Buka di tab baru jika link bukan internal anchor (#)
                      target={link.href.startsWith('#') ? '_self' : '_blank'}
                      rel="noopener noreferrer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Stay Connected with Social Icons */}
          <div>
            {/* DIUBAH: Teks judul seksi diubah menjadi 'text-white' */}
            <h3 className="font-bold mb-4 text-white">Stay Connected</h3>
            <div className="flex space-x-4">
              {/* 4. Ubah 'footer.socials.map' untuk menggunakan 'socialLinksMap'
                   'social' di sini adalah string: "instagram", "linkedin", "twitter"
              */}
              {footer.socials.map((social, index) => (
                <a
                  key={index}
                  // 5. Cari href di map yang baru dibuat
                  href={socialLinksMap[social] || '#'} // Gunakan map dinamis
                  target="_blank"
                  rel="noopener noreferrer"
                  // DIUBAH: Tombol sosial disesuaikan untuk dark mode
                  className="w-10 h-10 bg-gray-800/50 text-white rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors"
                  aria-label={`Follow us on ${social}`}
                >
                  {getSocialIcon(social)}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Cards Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {footer.cards.map((card, index) => (
            // DIUBAH: 'bg-gray-50' diubah menjadi 'bg-black/30 backdrop-blur-lg border'
            <div key={index} className="bg-black/30 backdrop-blur-lg border border-gray-700/50 rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300">
              {/* DIUBAH: Teks judul card diubah menjadi 'text-white' */}
              <h3 className="text-xl font-bold mb-3 text-white">{card.title}</h3>
              {/* DIUBAH: Teks deskripsi card diubah menjadi 'text-gray-300' */}
              <p className="text-gray-300 mb-4">{card.description}</p>
              {/* Link ini sudah OK */}
              <a
                href="#" // Anda mungkin ingin memperbarui href ini juga
                className="inline-flex items-center text-brand-blue-400 font-medium hover:text-brand-blue-300"
                target="_blank"
                rel="noopener noreferrer"
              >
                {card.cta}
                <ArrowRight className="w-4 h-4 ml-2" />
              </a>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        {/* DIUBAH: Border diubah menjadi 'border-gray-800' */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* DIUBAH: Teks copyright diubah menjadi 'text-gray-400' */}
            <p className="text-gray-400 text-sm text-center md:text-left">{footer.copyright}</p>
            <div className="flex flex-wrap justify-center md:justify-end gap-4">
              {footer.bottomLinks.map((link, index) => (
                // DIUBAH: Teks link bawah diubah menjadi 'text-gray-400'
                <a
                  key={index}
                  href={link.href}
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                  // Buka di tab baru jika link bukan internal anchor (#)
                  target={link.href.startsWith('#') ? '_self' : '_blank'}
                  rel="noopener noreferrer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;